import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";

const FAQS = [
  { q: "How long does NDIS registration typically take?", a: "Most providers complete registration in 10 to 16 weeks depending on registration groups, audit availability and complexity. Our average client registers in 11 weeks." },
  { q: "What is the difference between Stage 1 and Stage 2 audits?", a: "Stage 1 is a documentation audit reviewing your policies, procedures and evidence. Stage 2 is an on site (or virtual) audit involving interviews with management, staff and participants." },
  { q: "Do you guarantee registration success?", a: "We don't sell guarantees anyone who does should be questioned. We do offer a 98%+ audit pass rate and a structured remediation pathway if issues arise." },
  { q: "Can you help if I've already started or failed an audit?", a: "Yes. We regularly take on remediation engagements for providers who need to address corrective actions or rebuild their compliance system." },
  { q: "What registration groups can you support?", a: "All registration groups, including high risk classes like SIL, SDA, behaviour support and early childhood. Our team has experience across the full NDIS Practice Standards." },
  { q: "Are your policies templates or bespoke?", a: "Bespoke. We use a structured framework but tailor every policy to your services, staffing model and risk profile. Templates fail audits we don't ship them." },
  { q: "Do you offer payment plans?", a: "Yes. Most fixed fee packages can be split across the engagement milestones. We'll discuss this on your discovery call." },
  { q: "Do you work with providers in all states?", a: "Yes we work with providers across all states and territories. Most engagements are delivered remotely with on site visits as required." },
  { q: "How do you handle ongoing compliance?", a: "Through our retainer offering: quarterly reviews, real time advice, mid cycle audit prep and a senior consultant on call. Most clients move to retainer post registration." },
  { q: "Can I just buy your policy pack?", a: "No we don't sell standalone policy packs. Policies without the implementation context fail audits. We sell registration outcomes, not paperwork." },
];

export default function FAQs() {
  return (
    <div data-testid="faqs-page">
      <section className="container-pad pt-16 pb-12">
        <div className="overline">Frequently Asked Questions</div>
        <h1 className="font-display text-5xl sm:text-6xl text-navy mt-6 tracking-tight max-w-4xl leading-[1.05]">
          Honest answers to the questions every new provider asks.
        </h1>
      </section>

      <section className="container-pad pb-24">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12">
          <div className="md:col-span-4 md:sticky md:top-28 self-start">
            <p className="text-muted2 leading-relaxed">
              Can't see what you're looking for? Reach out we answer real questions on real calls.
            </p>
            <Link to="/contact" data-testid="faqs-contact-cta" className="btn-ghost-navy mt-6">
              Ask a question <ArrowUpRight size={16} />
            </Link>
          </div>
          <div className="md:col-span-8 card-soft p-2 sm:p-4">
            <Accordion type="single" collapsible className="w-full">
              {FAQS.map((f, idx) => (
                <AccordionItem
                  key={idx}
                  value={`item-${idx}`}
                  data-testid={`faq-${idx}`}
                  className="border-b border-hairline last:border-b-0 px-4"
                >
                  <AccordionTrigger className="text-left font-display text-lg text-navy hover:no-underline py-5">
                    {f.q}
                  </AccordionTrigger>
                  <AccordionContent className="text-muted2 leading-relaxed pb-5">
                    {f.a}
                  </AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          </div>
        </div>
      </section>
    </div>
  );
}
